export const WorkspaceConfig_PatientViewer = {
    name: 'Patient Viewer',
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'LeftPanel', key: 'processedPatientRenderer', visible: true, factor: 1 / 2, min: 200,
                data: {
                    filter: '',
                    selectedDiseaseProperty: undefined,
                }
            },
            {
                name: 'RightPanel', key: 'rawPatientRenderer', visible: true, factor: 1 / 2, min: 200,
                data: {}
            },
        ]
    }
};
